module.exports = __webpack_public_path__ + "static/img/spoken_cate.3a7b5fa.3a7b5fad.jpg";